import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=dc031256&scoped=true"
import script from "./notice-detail.vue?vue&type=script&lang=ts"
export * from "./notice-detail.vue?vue&type=script&lang=ts"
import style0 from "./notice-detail.vue?vue&type=style&index=0&id=dc031256&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc031256",
  null
  
)

export default component.exports